<div *ngFor="let alert of alerts" class="{{cssClass(alert)}}">
    <a class="close" (click)="removeAlert(alert)">&times;</a>
    <img width="15px" style="margin: 0% 2% 0% 2%;" [src]="imageUrl">
    <span class="success-alert" [innerHTML]="alert.message"></span>
</div>